import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import FacilityFrame from './facilityFrame';
import { xpForLevel, xpToNext, levelProgress, trainingCost, trainingBlocker } from '../utils/leveling';

// The training hall: raise characters a level at a time, for gold. There is
// one in town, and a trainer keeps a desk on every third floor below.
class TrainingHall extends Component {

  handleKeydown = (e) => {
    const { party, trainCharacter } = this.props.context;
    const slot = parseInt(e.key, 10) - 1;
    if (slot >= 0 && slot < party.length) trainCharacter(slot);
  }

  render() {
    const { facility, party, gold, trainCharacter } = this.props.context;
    if (facility !== 'training') return null;

    return (
      <FacilityFrame
        title="The Training Hall"
        quote='"Experience is earned below. Levels are earned here."'
        hint="Click TRAIN or press 1-6 · training raises one level at a time"
        onKey={this.handleKeydown}
      >
        <div className="training-list">
          {party.map((c, index) => {
            const blocker = trainingBlocker(c, gold);
            const cost = trainingCost(c);
            const progress = Math.round(levelProgress(c) * 100);
            return (
              <div key={c.id} className={classNames('training-row', { ready: !blocker })}>
                <span className="training-slot">{index + 1}</span>
                <div className="training-who">
                  <div className="training-name">{c.name} <span className="sheet-muted">{c.className} {c.level}</span></div>
                  <div className="sheet-muted">
                    {c.xp} xp · {progress}% of the way to level {c.level + 1}
                    {progress < 100 && ` · ${xpToNext(c)} to go (${xpForLevel(c.level + 1)} needed)`}
                  </div>
                </div>
                <button
                  className={classNames('menu-button', 'small', { disabled: !!blocker })}
                  onClick={() => trainCharacter(index)}
                >
                  TRAIN · {cost}g
                </button>
              </div>
            );
          })}
        </div>
      </FacilityFrame>
    );
  }
}

export default withContext(TrainingHall);
